import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center h-[80vh]">
      <h1 className="text-9xl font-extrabold text-yellow-500 tracking-widest">404</h1>
      <div className="bg-yellow-500 px-4 text-sm rounded rotate-6 absolute">
        Page Not Found
      </div>

      <p className="mt-8 text-lg text-gray-600 text-center max-w-md">
        Oops! The page you’re looking for doesn’t exist or has been moved.  
      </p>
      <button
        onClick={() => navigate("/")}
        className="mt-8 px-6 py-3 rounded-lg bg-yellow-500 text-white font-medium shadow-md transition-transform hover:scale-105 hover:bg-yellow-600"
      >
        Go Home
      </button>
    </div>
  );
};

export default NotFound;
